// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/boat-song.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const boatSong: Score = {
  slug: "boat-song",
  n: 29,
  title: "Boat Song",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "G",
  fifths: 1,
  time: [6, 8],
  tempo: 60,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 8,
  barQuarters: 3.0,
  lowest: 43,
  highest: 74,
  hasLyrics: false,
  jasonNote: "Six quavers in a bar, but you feel it in two \u2014 ONE two three, TWO two three, like a boat rocking. Count the big beats, not the little ones, and it will swing along by itself.",
  teaches: ["6/8 \u2014 compound time", "feeling two big beats in a bar", "quavers grouped in threes"],
  art: "/sight-reading/art/boat-song.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/boat-song.jpg",
  newForThisEdition: true,
  fillsGap: "The printed book contains no compound time \u2014 no 6/8 anywhere.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 0.5, midi: 62, pitch: "D4", d: "eighth" },
    { bar: 1, hand: "lh", start: 0.0, dur: 1.5, midi: 43, pitch: "G2", d: "quarter", dot: true },
    { bar: 1, hand: "rh", start: 0.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 1, hand: "rh", start: 1.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 1, hand: "rh", start: 1.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 1, hand: "lh", start: 1.5, dur: 1.5, midi: 50, pitch: "D3", d: "quarter", dot: true },
    { bar: 1, hand: "rh", start: 2.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 1, hand: "rh", start: 2.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 2, hand: "rh", start: 3.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 2, hand: "lh", start: 3.0, dur: 1.5, midi: 43, pitch: "G2", d: "quarter", dot: true },
    { bar: 2, hand: "rh", start: 3.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 2, hand: "rh", start: 4.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 2, hand: "rh", start: 4.5, dur: 1.5, midi: 69, pitch: "A4", d: "quarter", dot: true },
    { bar: 2, hand: "lh", start: 4.5, dur: 1.5, midi: 50, pitch: "D3", d: "quarter", dot: true },
    { bar: 3, hand: "rh", start: 6.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 3, hand: "lh", start: 6.0, dur: 1.5, midi: 45, pitch: "A2", d: "quarter", dot: true },
    { bar: 3, hand: "rh", start: 6.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 3, hand: "rh", start: 7.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 3, hand: "rh", start: 7.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 3, hand: "lh", start: 7.5, dur: 1.5, midi: 52, pitch: "E3", d: "quarter", dot: true },
    { bar: 3, hand: "rh", start: 8.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 3, hand: "rh", start: 8.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 4, hand: "rh", start: 9.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 4, hand: "lh", start: 9.0, dur: 1.5, midi: 45, pitch: "A2", d: "quarter", dot: true },
    { bar: 4, hand: "rh", start: 9.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 4, hand: "rh", start: 10.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 4, hand: "rh", start: 10.5, dur: 1.5, midi: 71, pitch: "B4", d: "quarter", dot: true },
    { bar: 4, hand: "lh", start: 10.5, dur: 1.5, midi: 52, pitch: "E3", d: "quarter", dot: true },
    { bar: 5, hand: "rh", start: 12.0, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 5, hand: "lh", start: 12.0, dur: 1.5, midi: 50, pitch: "D3", d: "quarter", dot: true },
    { bar: 5, hand: "rh", start: 12.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 5, hand: "rh", start: 13.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 5, hand: "rh", start: 13.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 5, hand: "lh", start: 13.5, dur: 1.5, midi: 57, pitch: "A3", d: "quarter", dot: true },
    { bar: 5, hand: "rh", start: 14.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 5, hand: "rh", start: 14.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 6, hand: "rh", start: 15.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 6, hand: "lh", start: 15.0, dur: 1.5, midi: 50, pitch: "D3", d: "quarter", dot: true },
    { bar: 6, hand: "rh", start: 15.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 6, hand: "rh", start: 16.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 6, hand: "rh", start: 16.5, dur: 1.5, midi: 69, pitch: "A4", d: "quarter", dot: true },
    { bar: 6, hand: "lh", start: 16.5, dur: 1.5, midi: 57, pitch: "A3", d: "quarter", dot: true },
    { bar: 7, hand: "rh", start: 18.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 7, hand: "lh", start: 18.0, dur: 1.5, midi: 50, pitch: "D3", d: "quarter", dot: true },
    { bar: 7, hand: "rh", start: 18.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 7, hand: "rh", start: 19.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 7, hand: "rh", start: 19.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 7, hand: "lh", start: 19.5, dur: 1.5, midi: 50, pitch: "D3", d: "quarter", dot: true },
    { bar: 7, hand: "rh", start: 20.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 7, hand: "rh", start: 20.5, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth" },
    { bar: 8, hand: "rh", start: 21.0, dur: 3.0, midi: 67, pitch: "G4", d: "half", dot: true },
    { bar: 8, hand: "lh", start: 21.0, dur: 3.0, midi: 43, pitch: "G2", d: "half", dot: true },
  ],
};
